<template>
  <ul class="navbar-nav">
    <li class="nav-item" :class="{ active: route.name == 'index' }">
      <router-link :to="{ name: 'index' }" class="nav-link">
        Início
        <span class="sr-only" v-if="route.name == 'index'">(atual)</span>
      </router-link>
    </li>
    <template v-if="selected_company != null && selected_standard != null">
      <li
        class="nav-item"
        :class="{
          active: route.path == '/machines/create' || route.path == '/confined-spaces/create',
        }"
      >
        <router-link 
          v-if="selected_standard.name != 'NR33' && authenticated_user !== 'Cliente somente leitura'"
          to="/machines/create"
          class="nav-link"
        >
          Novo lançamento
          <span class="sr-only" v-if="route.path == '/machines/create'"
            >(atual)</span
          >
        </router-link>
        <router-link
          v-if="selected_standard.name == 'NR33' && authenticated_user !== 'Cliente somente leitura'"
          to="/confined-spaces/create"
          class="nav-link"
        >
          Novo lançamento
          <span class="sr-only" v-if="route.path == '/confined-spaces/create'"
            >(atual)</span
          >
        </router-link>
      </li>
      <li
        class="nav-item"
        :class="{
          active: route.path.endsWith('/machines'),
        }"
      >
        <router-link v-if="selected_standard.name != 'NR33'" to="/machines" class="nav-link">
          Inventário
          <span class="sr-only" v-if="route.path.endsWith('/machines')"
            >(atual)</span
          >
        </router-link>
        <router-link v-if="selected_standard.name == 'NR33'" to="/confined-spaces" class="nav-link">
          Inventário
          <span class="sr-only" v-if="route.path.endsWith('/confined-spaces')"
            >(atual)</span
          >
        </router-link>
      </li>
      <li
        class="nav-item"
        :class="{
          active: route.path.includes('preliminary-risk-analyses')
        }"
      >
        <router-link
          v-if="selected_standard.name != 'NR33'"
          :to="{ name: 'preliminary-risk-analyses' }"
          class="nav-link"
        >
          Análise de Risco
          <span class="sr-only" v-if="route.path.includes('preliminary-risk-analyses')"
            >(atual)</span
          >
        </router-link>
        <router-link
          v-if="selected_standard.name == 'NR33'"
          to="/confined-spaces/preliminary-risk-analyses"
          class="nav-link"
        >
          Análise de Risco
          <span class="sr-only"  v-if="route.path.includes('preliminary-risk-analyses')"
            >(atual)</span
          >
        </router-link>
      </li>
      <li
        class="nav-item"
        :class="{
          active: route.name == 'action-plan',
        }"
      >
        <router-link
          v-if="selected_standard.name != 'NR33'"
          :to="{ name: 'action-plan' }"
          class="nav-link"
        >
          Plano de Ação
          <span class="sr-only" v-if="route.name == 'action-plan'"
            >(atual)</span
          >
        </router-link>
        <router-link
          v-if="selected_standard.name == 'NR33'"
          :to="{ name: 'confined-spaces-action-plan' }"
          class="nav-link"
        >
          Plano de Ação
          <span class="sr-only" v-if="route.name == 'action-plan'"
            >(atual)</span
          >
        </router-link>
      </li>
      <li
      class="nav-item"
      :class="{
        active: route.path.includes('/work-front'),
      }"
    >
      <router-link to="/work-front" class="nav-link">
        Frentes de Trabalho
        <span
          class="sr-only"
          v-if="route.path.includes('/work-front')"
          >(atual)</span
        >
      </router-link>
    </li>
      <!-- <li
				class="nav-item"
				v-bind:class="{
					active: route.name == 'methodology',
				}"
			>
				<router-link :to="{ name: 'methodology' }" class="nav-link">
					Metodologia
					<span class="sr-only" v-if="route.name == 'methodology'">(atual)</span>
				</router-link>
			</li>
			<li
				class="nav-item"
				v-bind:class="{
					active: route.name == 'ART',
				}"
			>
				<router-link :to="{ name: 'ART' }" class="nav-link">
					ART
					<span class="sr-only" v-if="route.name == 'ART'">(atual)</span>
				</router-link>
			</li> -->
    </template>
    <li v-if="selected_standard != null" class="nav-item d-flex align-items-center ml-3">
      <span class="badge badge-info">{{ selected_standard.name }}</span>
    </li>
  </ul>
</template>

<script>
  import { computed } from 'vue'
  import { useRouter } from 'vue-router'
  import { useStore } from 'vuex'

  export default {
    name: 'App',
    setup() {
      const { currentRoute } = useRouter()

      const store = useStore()

      const selected_company = computed(() => store.getters.selected_company)
      const selected_standard = computed(() => store.getters.selected_standard)
      const authenticated_user = computed(() => store.getters.authenticated_user.user_profile.name)

      return {
        route: currentRoute,
        selected_company,
        selected_standard,
        authenticated_user
      }
    },
  }
</script>
